import { kanbanViewConfig } from './presets/kanban/renderer.js';
import { tableViewConfig } from './presets/table/renderer.js';

export const viewPresets = {
  tableViewConfig,
  kanbanViewConfig,
};
